import React from 'react'
import { Row } from 'react-bootstrap';

interface RefundPolicyProps {
    title: string;
}

export const RefundPolicy = (props: RefundPolicyProps) => {
    const { title } = props;
    return (
        <Row className="p-3 pb-5 g-4 open-up" data-aos="zoom-out">
            <h5 className='mb-3'>{ title }</h5>
            <div className="mb-4">
                <p className='text-muted' style={{ fontSize: '1rem' }}>
                    At Easysauces Nigeria limited, we strive to provide the highest quality cooking sauce products. 
                    If for any reason you're not satisfied with your purchase, we offer a refund policy as follows:
                </p>

                <p className='text-muted' style={{ fontSize: '.9rem' }}>
                
                    <h5 style={{ fontSize: '1rem', fontWeight: 600 }} className='mt-5'>Eligibility for Refund:</h5>

                    <p>To be eligible for a refund, the following conditions must be met:</p>

                    <ol className='text-muted'>
                        <li>The product must be returned within 3 days of delivery.</li>
                        <li>The product must be in its original, unopened packaging.</li>
                        <li>The product must be in good condition, with no damage or tampering.</li>
                    </ol>

                    <h5 style={{ fontSize: '1rem', fontWeight: 600 }} className='mt-5'>Refund Process:</h5>
                    
                    <p>If you're eligible for a refund, please follow these steps:</p>
                    
                    <ol className='text-muted'>
                        <li>Contact our customer service team via email <a href='mailto:info@easysauces.com'>info@easysauces.com</a> or phone to initiate the refund process.</li>
                        <li>Provide your order number, reason for return, and any supporting photos or documentation.</li>
                        <li>We'll process your refund within 14 working days of receiving the returned product at nearest Easysauces store.</li>
                    </ol>
                    
                    <h5 style={{ fontSize: '1rem', fontWeight: 600 }} className='mt-5'>Refund Amount:</h5>
                    <p>The refund amount will be the full purchase price of the product, minus any shipping costs.</p>
                    
                    <h5 style={{ fontSize: '1rem', fontWeight: 600 }} className='mt-5'>Exceptions:</h5>
                    <p>Please note that we cannot accept returns or provide refunds for:</p>
                    <ol className='text-muted'>
                        <li>Products that have been opened or tampered with.</li>
                        <li>Products that are past their expiration date (12 months from the date of manufacture).</li>
                        <li>Products that is damaged or defective due to customer negligence or misuse.</li>
                    </ol>
                    <p>By purchasing from our website, you acknowledge that you've read, understood, and agree to be bound by this Refund Policy.</p>
                    
                    <p>Thank you for choosing,</p>
                    <h5 style={{ fontSize: '1rem', fontWeight: 400 }}>Easysauces Nigeria limited.</h5>
                </p>
            </div>
        </Row>
    )
}
